module.exports = __webpack_public_path__ + "media/assets/images/layout/img-wizard-break-e09126b31474d68ba70e836a6d6423f9.png";